// Invoice subtypes (Doctrine SINGLE_TABLE discriminator on Invoice).
// Mirrors the legacy backoffice `InvoiceType` enum. The list "Invoice type"
// filter switches the collection endpoint to `path` (e.g. /credit_invoices),
// exactly like the old backoffice — there is no discriminator query filter.
// `creatable` marks the subtypes the overview's create wizard can produce
// standalone (no cart): Credit + Debit. Sales is created at checkout; the
// adjustment subtypes require a cart and are created from the cart view.

export interface InvoiceTypeDef {
  // serialized @type / Doctrine discriminator
  type: string
  // API Platform collection path segment
  path: string
  label: string
  creatable: boolean
}

export const INVOICE_TYPES: Record<string, InvoiceTypeDef> = {
  SalesInvoice: { type: 'SalesInvoice', path: 'sales_invoices', label: 'Sales', creatable: false },
  CreditInvoice: {
    type: 'CreditInvoice',
    path: 'credit_invoices',
    label: 'Credit',
    creatable: true
  },
  DebitInvoice: { type: 'DebitInvoice', path: 'debit_invoices', label: 'Debit', creatable: true },
  CreditAdjustmentInvoice: {
    type: 'CreditAdjustmentInvoice',
    path: 'credit_adjustment_invoices',
    label: 'Credit adjustment',
    creatable: false
  },
  DebitAdjustmentInvoice: {
    type: 'DebitAdjustmentInvoice',
    path: 'debit_adjustment_invoices',
    label: 'Debit adjustment',
    creatable: false
  }
}

export const invoiceTypeOptions = Object.values(INVOICE_TYPES).map((t) => ({
  label: t.label,
  value: t.type
}))

export const creatableInvoiceTypeOptions = Object.values(INVOICE_TYPES)
  .filter((t) => t.creatable)
  .map((t) => ({ label: t.label, value: t.type }))

// @type -> collection path segment (e.g. 'CreditInvoice' -> 'credit_invoices').
export const invoiceTypePath = (atType: string | null | undefined): string | null =>
  atType && INVOICE_TYPES[atType] ? INVOICE_TYPES[atType].path : null
